<template>
  <div
    class="modal-faq-body"
    v-if="modal"
    style="
      background-color: #fff;
      position: absolute;
      top: 50px;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 999;
      display: grid;
      justify-content: center;
    "
  >
    <div
      @click="(e) => e.stopPropagation()"
      class="no-scrollbar"
      style="
        width: 100%;
        padding: 1rem;
        background-color: #fff;
        border-radius: 0.5rem;
        text-align: start;
        display: flex;
        flex-direction: column;
        gap: 2rem;
        height: 100dvh;
        overflow: auto;
        padding-bottom: 4rem;
        padding-top: 2rem;
      "
    >
      <header
        style="
          display: flex;
          justify-content: center;
          align-items: center;

          position: relative;
        "
      >
        <div @click="goMap" id="trigger" class="mobile">
          <img src="../assets/arrow-left.svg" /> 戻る
        </div>
        <span style="font-weight: bold; text-align: center">目次</span>
      </header>
      <div class="text-list">
        <div class="link" id="linka">
          <BIconChevronCompactRight color="#95c41c" /> アカウントを作成する
        </div>
        <div class="link" id="linkb">
          <BIconChevronCompactRight color="#95c41c" /> 見積プロセス
        </div>
        <span class="link sub" id="linkba">ポスティング</span>
        <span class="link sub" id="linkbd">印刷＋ポスティング</span>
        <span class="link sub" id="linkbb">新聞折込</span>
        <span class="link sub" id="linkbc">DSP配信</span>

        <div class="link" id="linkc">
          <BIconChevronCompactRight color="#95c41c" /> カート内プロセス
        </div>
        <div class="link" id="linkd">
          <BIconChevronCompactRight color="#95c41c" /> 注文管理画面
        </div>
        <div class="link" id="linke">
          <BIconChevronCompactRight color="#95c41c" /> セグメント機能
        </div>
        <div class="link" id="linkg">
          <BIconChevronCompactRight color="#95c41c" />一括見積もり
        </div>
        <div class="link" id="linkh">
          <BIconChevronCompactRight color="#95c41c" />見積もり条件検索
        </div>
        <div class="link" id="linkj">
          <BIconChevronCompactRight color="#95c41c" /> 印刷データ入稿時の注意
        </div>
        <div class="link" id="linkf">
          <BIconChevronCompactRight color="#95c41c" /> 免責事項
        </div>
      </div>
    </div>
  </div>
  <Header />
  <div class="container container-faq">
    <div class="header">
      <div @click="goMap" class="trigger all">
        <img src="../assets/arrow-left.svg" /> 戻る
      </div>
      <div @click="modal = true" class="trigger">戻る</div>
      <h4>ご利用ガイド</h4>
    </div>
    <div class="main">
      <section id="nav">
        <h4>目次</h4>
        <div class="text-list">
          <div class="link active" id="linka">
            <BIconChevronCompactRight color="#95c41c" /> アカウントを作成する
          </div>
          <div class="link" id="linkb">
            <BIconChevronCompactRight color="#95c41c" /> 見積プロセス
          </div>

          <span class="link sub" id="linkba">ポスティング</span>
          <span class="link sub" id="linkbyoff">yoff</span>
          <span class="link sub" id="linkbd">印刷＋ポスティング</span>
          <span class="link sub" id="linkbb">新聞折込</span>
          <span class="link sub" id="linkbc">DSP配信</span>

          <div class="link" id="linkc">
            <BIconChevronCompactRight color="#95c41c" /> カート内プロセス
          </div>
          <div class="link" id="linkd">
            <BIconChevronCompactRight color="#95c41c" />注文管理画面
          </div>
          <div class="link" id="linke">
            <BIconChevronCompactRight color="#95c41c" />セグメント機能
          </div>
          <div class="link" id="linkg">
            <BIconChevronCompactRight color="#95c41c" />一括見積もり
          </div>
          <div class="link" id="linkh">
            <BIconChevronCompactRight color="#95c41c" />見積もり条件検索
          </div>
          <div class="link" id="linkj">
            <BIconChevronCompactRight color="#95c41c" /> 印刷データ入稿時の注意
          </div>
          <div class="link" id="linkf">
            <BIconChevronCompactRight color="#95c41c" />免責事項
          </div>
        </div>
      </section>
      <section id="main">
        <!-- first faq -->
        <div v-if="currentSection == 1">
          <h4 style="font-size: 1.3rem; padding: 2rem">アカウントを作成する</h4>
          <main class="content">
            <p>
              見積書の作成はアカウント登録なしで行えますが、それ以上の注文はアカウント登録が必要です。
            </p>
            <HeaderFaq
              title="初めてサイトを開くと、以下のページが表示されますので、ページ右上の「新規会員登録」ボタンをクリックしてください"
              no="1"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-register/1.png"
            />
            <HeaderFaq title="各項目に記入をお願いします。" no="2" />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-register/2.png"
            />
            <HeaderFaq
              title="登録フォームを完了すると、アカウントを確認するための電子メールが送信されます。そのメールにアクセスし、確認ボタンをクリックしてください。"
              no="3"
            />
            <HeaderFaq
              title="認証されると、アカウントは使用できるようになります。"
              no="4"
            />
            <p style="margin-left: 44px;">アカウントの登録が行えない場合</p>
            <p style="margin-left: 44px;">
              アカウントは1ユーザーあたり1アカウント、1法人当たり1グループとなっておりますため、電話番号やメールアドレスが既に登録済のアカウントと重複している場合は新規の登録を行う事ができません。
              法人内で複数のアカウントを用いたい場合は、作成済みのアカウントでログインし、
              トップ画面の『アカウント追加・削除』ページからアカウントの追加を行って下さい。
            </p>
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-register/5.png"
            />
          </main>
          <!-- first faq -->
        </div>

        <!-- second faq -->
        <div v-if="currentSection == 2">
          <h4 id="head2" style="font-size: 1.3rem; padding: 2rem 0">
            見積プロセス - ポスティング
          </h4>
          <main class="content">
            <p>
              見積書の作成はアカウント登録なしで行えますが、それ以上の注文はアカウント登録が必要です。アカウントの登録方法については、<a
                href="/term?section=1"
              >
                こちら</a
              >をクリックしてください。<br />
            </p>
            <HeaderFaq
              title="ホーム画面の「地図から注文する」をクリックすると地図画面が表示されます。"
              no="1"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-print/1.png"
            />
            <HeaderFaq
              title="中心住所の選択 <br/>
ポスティング用の地図になっているかを確認し、検索セクションで配布を行いたいエリアの住所を入力してください。住所入力後に地図画面がご入力した住所に移動します。 <br/>
中心点となるポイントをドラッグする事で微調整が行えます。"
              no="2"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-posting/2.webp"
            />
            <HeaderFaq
              title="印刷有無の選択 <br/>
ポスティングのみ依頼か、印刷とポスティングの両方を依頼かを選択してください。
このページは『ポスティングのみ注文する』場合のガイドとなります。"
              no="3"
            />
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-posting/3.webp"
            />
            <HeaderFaq
              title="目安部数の入力 <br/>
配布を行いたい希望の数量を入力してください。<br/>
中心点から近いエリアで希望の数量に達するエリアが選定されます。"
              no="4"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-posting/4.webp"
            />
            <HeaderFaq
              title="エリア単位 <br/>
町丁目 ＝ 町丁目単位で選択を行う基本的な方法です。<br/>
市区町村単位　＝　市区単位で選択を行う広域エリアでの選択方法です。"
              no="5"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-posting/5.webp"
            />
            <HeaderFaq
              title="半径の入力<br/>
配布を行いたい距離圏が決まっている場合はこちらに入力してください。<br/>
ご入力頂いた半径にてエリアが選定されます。<br/>
また、地図に表示されている円上の4点のいずれかをドラッグすることで半径の調整を行うことも可能です。"
              no="6"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-posting/6.webp"
            />
            <HeaderFaq
              title="納品予定日と配布完了予定日<br/>
クリックするとカレンダーが表示されますので、
納品予定日→配布完了予定日の順に日にちをクリックして下さい。<br/>
スケジュール的に対応が行えない日にちはクリックできませんのでご了承下さい。"
              no="7"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-posting/7.webp"
            />
            <HeaderFaq
              title="配布方法<br/>
ご希望の配布方法を選択してください。"
              no="8"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-posting/8.webp"
            />
            <HeaderFaq
              title="配布物のサイズ選択<br/>
配布物のサイズを選択してください。<br/>
A4より大きいサイズの場合はA4(B5)サイズ以下まで折加工をしたうえでのご納品が必要となりますが、
こちらでは展開時のサイズにて選択してください。<br/>
折なしの状態でのご納品となる場合は別途お問合せ下さい。"
              no="9"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-posting/9.webp"
            />
            <HeaderFaq
              title="エリアの修正<br/>
地図画面上でエリアの細かい修正が可能です。<br/>
青色で表示されているエリアが未選択のエリア、赤色で表示されているエリアが選択済のエリアとなります。<br/>
各エリアをクリックする事でエリアの追加・削除が可能です。"
              no="10"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-posting/10.webp"
            />
            <HeaderFaq
              title="カートへ入れる<br/>
見積結果が表示されますので、見積書が必要であれば「見積書を発行する」をクリック<br/>
内容に問題が無ければ「カートへ追加する」をクリックしてください。"
              no="11"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-posting/11.webp"
            />
            <HeaderFaq
              title="チラシ名称の入力 <br/>
こちらにチラシの名称を入力してください。<br/>チラシ名称は社名・店名、広告の内容等、なるべく具体的にわかるような名称でご入力下さい。<br/>【飲食店広告】・【キャンペーン広告】・【求人広告】などの名称の場合 チラシ納品時に判別ができず、配布が進められない可能性がございます。<br/>
　    例：【〇〇居酒屋△△店 ××キャンペーン広告】<br/>
　　　【〇〇株式会社 △△作業 求人広告】<br/>
　　　【〇〇不動産 △△建物 入居者募集広告】　等"
              no="12"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-posting/12.webp"
            />
            <a class="link-href" @click="goTo5thPage">「カート内プロセス」へ進む</a>
          </main>
        </div>

        <!-- yoff -->
         <div v-if="currentSection == 15">
          <h4 id="head2" style="font-size: 1.3rem; padding: 2rem 0">
            見積プロセス‐yoff(タワマン同梱配布)
          </h4>
          <main class="content">
            <p>
              見積書の作成はアカウント登録なしで行えますが、それ以上の注文はアカウント登録が必要です。アカウントの登録方法については、<a
                href="/term?section=1"
              >
                こちら</a
              >をクリックしてください。<br />
            </p>
            <p>
              yoffのサービス詳細に関しては<a
                href="https://yoff.life/lp/"
                target="_blank"
              >
                こちら</a
              >をご確認下さい。都心富裕層向けポスティングマガジン yoff へのチラシ同梱。<br />
            </p>
            <HeaderFaq
              title="yoffのオプションを選択 <br/>
                地図注文画面のタワーマンション OPTION：富裕層向けマンションへの配布 のチェックボックスをクリックします。"
              no="1"
            />
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-guide-yoff/yoff-1.webp"
            />
            
          <HeaderFaq
              title="各物件の実施有無を選択 <br/>
                チェックボックスをクリックすると対応可能な物件にポイントが表示されます。
                カーソルを合わせると物件の詳細が表示され、クリックで配布有無の選択が可能です。<br/>
                ※通常のポスティングエリアとして選択中のエリア内の物件のみ選択可能です。
                "
              no="2"
            />
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-guide-yoff/yoff-2.webp"
            />
          
            <HeaderFaq
              title="配布日程、金額の確認 <br/>
                お見積り欄にyoff同梱配布の配布日程と金額が表示されますのでご確認下さい。<br/>
                ※yoffの配布日程は通常配布の日程とは異なります。
                "
              no="3"
            />
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-guide-yoff/yoff-3.webp"
            />

            <HeaderFaq
              title="カートへ入れる <br/>
                見積結果が表示されますので、見積書が必要であれば「見積書を発行する」をクリック<br/>
                内容に問題が無ければ「カートへ追加する」をクリックしてください。
                "
              no="4"
            />
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-guide-yoff/yoff-4.webp"
            />
            
            <HeaderFaq
              title="チラシ名称の入力 <br/>
                こちらにチラシの名称を入力してください。<br/>
                チラシ名称は社名・店名、広告の内容等、なるべく具体的にわかるような名称でご入力下さい。<br/>
              【飲食店広告】・【キャンペーン広告】・【求人広告】などの名称の場合 チラシ納品時に判別ができず、配布が進められない可能性がございます。<br/>
                例：【〇〇居酒屋△△店 ××キャンペーン広告】<br/>
              　　【〇〇株式会社 △△作業 求人広告】<br/>
              　　【〇〇不動産 △△建物 入居者募集広告】　等
                "
              no="5"
            />
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-guide-yoff/yoff-5.webp"
            />

            <a class="link-href" @click="goTo5thPage">「カート内プロセス」へ進む</a>

          </main>
        </div>
        <!-- end yoff -->

        <div v-if="currentSection == 11">
          <h4 id="head2" style="font-size: 1.3rem; padding: 2rem 0">
            見積プロセス - 印刷＋ポスティング
          </h4>
          <main class="content">
            <p>
              見積書の作成はアカウント登録なしで行えますが、それ以上の注文はアカウント登録が必要です。アカウントの登録方法については、<a
                href="/term?section=1"
              >
                こちら</a
              >をクリックしてください。<br />
            </p>
            <HeaderFaq
              title="ホーム画面の「地図から注文する」をクリックすると地図画面が表示されます。"
              no="1"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-print/1.png"
            />
            <HeaderFaq
              title="中心住所の選択 <br/>
ポスティング用の地図になっているかを確認し、検索セクションで配布を行いたいエリアの住所を入力してください。住所入力後に地図画面がご入力した住所に移動します。 <br/>
中心点となるポイントをドラッグする事で微調整が行えます。"
              no="2"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-print/2.webp"
            />
            <HeaderFaq
              title="印刷有無の選択 <br/>
ポスティングのみ依頼か、印刷とポスティングの両方を依頼かを選択してください。 このページは『印刷とポスティングの両方を注文する』場合のガイドとなります。"
              no="3"
            />
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-print/3.webp"
            />
            <HeaderFaq
              title="目安部数の入力 <br/>
配布を行いたい希望の数量を入力してください。<br/>
中心点から近いエリアで希望の数量に達するエリアが選定されます。"
              no="4"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-print/4.webp"
            />
            <HeaderFaq
              title="エリア単位 <br/>
町丁目 ＝ 町丁目単位で選択を行う基本的な方法です。<br/>
市区町村単位　＝　市区単位で選択を行う広域エリアでの選択方法です。"
              no="5"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-print/5.webp"
            />
            <HeaderFaq
              title="半径の入力<br/>
配布を行いたい距離圏が決まっている場合はこちらに入力してください。<br/>
ご入力頂いた半径にてエリアが選定されます。<br/>
また、地図に表示されている円上の4点のいずれかをドラッグすることで半径の調整を行うことも可能です。"
              no="6"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-print/6.webp"
            />
            <HeaderFaq
              title="入稿予定日と配布完了予定日<br/>
クリックするとカレンダーが表示されますので、
納品予定日→配布完了予定日の順に日にちをクリックして下さい。<br/>
スケジュール的に対応が行えない日にちはクリックできませんのでご了承下さい。"
              no="7"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-print/7.webp"
            />
            <HeaderFaq
              title="配布方法<br/>
ご希望の配布方法を選択してください。"
              no="8"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-print/8.webp"
            />
            <HeaderFaq
              title="配布物のサイズ選択<br/>
配布物のサイズを選択してください。<br/>
A4より大きいサイズの場合はA4(B5)サイズ以下まで折加工をしたうえでのご納品が必要となりますが、
こちらでは展開時のサイズにて選択してください。<br/>
折なしの状態でのご納品となる場合は別途お問合せ下さい。"
              no="9"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-print/9.webp"
            />
            <HeaderFaq
              title="用紙と色の選択、お手元送付分の有無<br/>
用紙と色の選択、お手元送付分の有無
各選択肢の中からご希望の内容にて選択してください。"
              no="10"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-print/10.webp"
            />
            <HeaderFaq
              title="エリアの修正<br/>
地図画面上でエリアの細かい修正が可能です。<br/>
青色で表示されているエリアが未選択のエリア、赤色で表示されているエリアが選択済のエリアとなります。<br/>
各エリアをクリックする事でエリアの追加・削除が可能です。"
              no="11"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-print/11.webp"
            />
            <HeaderFaq
              title="カートへ入れる<br/>
見積結果が表示されますので、見積書が必要であれば「見積書を発行する」をクリック<br/>
内容に問題が無ければ「カートへ追加する」をクリックしてください。"
              no="12"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-print/12.webp"
            />
            <HeaderFaq
              title="チラシ名称の入力 <br/>
こちらにチラシの名称を入力してください。<br/>チラシ名称は社名・店名、広告の内容等、なるべく具体的にわかるような名称でご入力下さい。<br/>【飲食店広告】・【キャンペーン広告】・【求人広告】などの名称の場合 チラシ納品時に判別ができず、配布が進められない可能性がございます。<br/>
　    例：【〇〇居酒屋△△店 ××キャンペーン広告】<br/>
　　　【〇〇株式会社 △△作業 求人広告】<br/>
　　　【〇〇不動産 △△建物 入居者募集広告】　等"
              no="13"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-print/13.webp"
            />
          </main>
          <a class="link-href" @click="goTo5thPage">「カート内プロセス」へ進む</a>
        </div>

        <div v-if="currentSection == 3">
          <h4 style="font-size: 1.3rem; padding: 2rem 0">
            見積プロセス - 新聞折込
          </h4>
          <main class="content">
            <p>
              見積書の作成はアカウント登録なしで行えますが、それ以上の注文はアカウント登録が必要です。アカウントの登録方法については、<a
                href="/term?section=1"
              >
                こちら</a
              >をクリックしてください。<br />
            </p>
            <HeaderFaq
              title="ホーム画面の「地図から注文する」をクリックすると地図画面が表示されます。"
              no="1"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-orikomi/1.png"
            />
            <HeaderFaq
              title="新聞折込用の地図になっているかを確認し、検索セクションで新聞折込を行いたいエリアの住所を入力してください。"
              no="2"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-orikomi/2.png"
            />
            <HeaderFaq
              title="折込日の設定<br/>新聞折込を行いたい日付を選択してください。<br/>
スケジュール的に対応が行えない日にちはクリックできませんのでご了承下さい。"
              no="3"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-orikomi/3.png"
            />
            <HeaderFaq
              title="半径の入力<br/>
配布を行いたい距離圏が決まっている場合はこちらに入力してください。<br/>
ご入力頂いた半径にてエリアが選定されます。<br/>
また、地図に表示されている円上の4点のいずれかをドラッグすることで半径の調整を行うことも可能です。"
              no="4"
            />
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-orikomi/4.png"
            />
            <HeaderFaq
              title="新聞銘柄の選択<br/>新聞折込を実施したい新聞銘柄にチェックをいれてください"
              no="5"
            />
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-orikomi/5.png"
            />
            <HeaderFaq
              title="サイズの選択<br/> 用紙のサイズを選択してください。<br/>B4より大きいサイズの場合はB4サイズ以下まで折加工をしたうえでのご納品が必要となりますが、
こちらでは展開時のサイズにて選択してください。<br/>
折なしの状態でのご納品となる場合は別途お問合せ下さい。"
              no="6"
            />
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-orikomi/6.png"
            />
            <HeaderFaq
              title="紙厚の選択<br/>用紙の厚さを選択してください。"
              no="7"
            />
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-orikomi/7.png"
            />
            <HeaderFaq
              title="カートへ入れる<br/>
見積結果が表示されますので、見積書が必要であれば「見積書を発行する」をクリック<br/>
内容に問題が無ければ「カートへ追加する」をクリックしてください。"
              no="8"
            />
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-orikomi/8.png"
            />
            <HeaderFaq
              title="チラシ名称の入力 <br/>こちらにチラシの名称を入力してください。<br/>チラシ名称は社名・店名、広告の内容等、なるべく具体的にわかるような名称でご入力下さい。<br/>【飲食店広告】・【キャンペーン広告】・【求人広告】などの名称の場合、チラシ納品時に判別ができず、配布が進められない可能性がございます。<br/>
　 例：【〇〇居酒屋△△店 ××キャンペーン広告】<br/>
　　　【〇〇株式会社 △△作業 求人広告】<br/>
　　　【〇〇不動産 △△建物 入居者募集広告】　等 "
              no="9"
            />
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-orikomi/9.png"
            />
          </main>
          <a class="link-href" @click="goTo5thPage">「カート内プロセス」へ進む</a>
        </div>

        <!-- Geenie -->
        <div v-if="currentSection == 4">
          <h4 style="font-size: 1.3rem; padding: 2rem 0">
            見積プロセス - DSP配信
          </h4>
          <main class="content">
            <p>
              見積書の作成はアカウント登録なしで行えますが、それ以上の注文はアカウント登録が必要です。アカウントの登録方法については、<a
                href="/term?section=1"
              >
                こちら</a
              >をクリックしてください。<br />
            </p>
            <HeaderFaq title="メニューで「地図から注文」を選ぶ。" no="1" />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-geenie/1.png"
            />
            <HeaderFaq
              title="DSP配信」タブに入っていることを確認してください。その後、画面左のフォームに入力します。注文名、アップロード画像、ウェブサイトのURL、注文の予算を入力してください。"
              no="2"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-geenie/2.png"
            />
            <HeaderFaq
              title="ご注文をカートに入れる前に、ご注文内容の確認画面が表示されます。次に進むには、「カートに入れる」ボタンをクリックしてください。"
              no="3"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-geenie/3.png"
            />
            <HeaderFaq
              title="ご注文がカートに入ったら、メニューに戻ってお支払いを進めてください。"
              no="4"
            />
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-geenie/4.png"
            />
            <!-- <HeaderFaq
              title="カート上の注文リストから、支払いたい注文を承認する。お支払いの前に、必ずご注文の詳細をお読みください。"
              no="5"
            /> -->
            <!-- <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-geenie/5.png"
            />
            <HeaderFaq
              title="ご希望のお支払い方法をお選びください。ご注文の合計金額が表示されます。その後、お支払いにお進みください。"
              no="6"
            />
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-geenie/6.png"
            />
            <HeaderFaq
              title="注文の進捗状況を確認するには、メニューの一番下にあるDSP配信注文管理ボタンをクリックします。"
              no="7"
            />
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-geenie/7.png"
            />
            <HeaderFaq
              title="このセクションには注文リストが表示されます。各オーダーを選択して進捗状況を確認することができます。"
              no="8"
            />
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-geenie/8.png"
            />
            <HeaderFaq
              title="一つの注文をクリックすると、詳細な注文情報が表示され、注文の進捗状況を確認することができます。"
              no="9"
            />
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-map-geenie/9.png"
            /> -->
            <a class="link-href" @click="goTo5thPage">「カート内プロセス」へ進む</a>
          </main>
        </div>

        <!-- Geenie -->

        <!-- thrid faq -->
        <div v-if="currentSection == 5">
          <h4 style="font-size: 1.3rem; padding: 2rem 0">カート内プロセス</h4>
          <main class="content">
            <p>
              お支払いの確認と実行のために、このガイドをよくお読みください。
            </p>

            <HeaderFaq
              title="カートへ移行 <br/>
こちらのボタンをクリックするとカート画面へ移行する事ができます。"
              no="1"
            />
            <img style="padding-bottom: 1rem" src="../assets/flow-cart/1.png" />
            <HeaderFaq
              title="注文内容の確定<br/>
内容をご確認いただき、問題が無ければ「お支払方法の登録へ進む」をクリックして下さい。<br/>
注文内容を変更したい場合は「注文内容の編集」をクリックするとエリア作成画面に戻り、再度編集が可能となります。"
              no="2"
            />
            <img style="padding-bottom: 1rem" src="../assets/flow-cart/2.webp" />
            <HeaderFaq
              title="お支払方法の登録 <br/>
こちらからお支払方法を選択してください。<br/>
クレジットカードをご利用の場合は、「ここからカード登録と編集」をクリックし、登録作業を進めてください。<br/>お支払方法の選択が完了したら、
「注文の確定」をクリックしてください。"
              no="3"
            />
            <img style="padding-bottom: 1rem" src="../assets/flow-cart/3.png" />
            <HeaderFaq
              title="免責事項の確認<br/>免責事項が表示されますので最後までお読みください。<br/>
ご確認のうえご了承頂けるのであれば、「注文の確定」ボタンをクリックしてください。"
              no="4"
            />
            <img style="padding-bottom: 1rem" src="../assets/flow-cart/4.png" />
            <HeaderFaq
              title="免責事項の確認 <br/>
免責事項が表示されますので最後までお読みください。<br/>
ご確認のうえご了承頂けるのであれば、「注文の確定」ボタンをクリックしてください。"
              no="5"
            />
            <img style="padding-bottom: 1rem" src="../assets/flow-cart/5.png" />
          </main>
        </div>
        <!-- order management -->
        <div v-if="currentSection == 6">
          <h4 id="head3" style="font-size: 1.3rem; padding: 2rem 0">
            注文管理画面
          </h4>
          <main class="content">
            <p>
              カートの手続きを完了した後、注文手続きを完了するには、まず以下の注文条件を満たす必要があります。
            </p>

            <HeaderFaq
              title="注文管理画面へ移行<br/>
ホーム画面から選択した注文に応じて、「ポスティング」、「新聞折込」、「DSP配信」のいずれかをクリックします"
              no="1"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-order/1.png"
            />
            <HeaderFaq
              title="原稿アップロード<br/>
こちらから原稿データのアップロード
をお願い致します。"
              no="2"
            />
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-order/2.png"
            />
            <HeaderFaq
              title="原稿データの確認<br/>
原稿データのアップロード後に念のためこちらからアップロードデータに間違いが無
いかご確認下さい。 データを変更したい場合は再度『ファイルの選択』を押し、上か
ら再アップロードが可能です。"
              no="3"
            />

            <HeaderFaq
              title="原稿審査<br/>
アップロードが完了しましたら、原稿データの審査が完了するまでお待ち下さい。　審査が完了しましたら発送先情報が更新されます。 審査には1～2営業日要する場合がございます。"
              no="4"
            />
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-order/4.png"
            />
            <HeaderFaq
              title="お支払の確認<br/>
原稿審査完了後、お支払いに関しての必要な情報が表示されますのでご確認下さい。"
              no="5"
            />

            <HeaderFaq
              title="発送先情報の確認<br/>
原稿審査が完了しましたらご登録されたメールアドレスに完了の連絡が入ります。<br/>
こちらより配布物の発送先が情報が更新されますのでご確認いただき、 発送の対応をお願い致します。"
              no="6"
            />

            <HeaderFaq
              title="配布物の発送<br/>
発送が完了しましたら分かり次第で追跡番号のご入力をお願い致します。 納品予定日
までにご納品をお願い致します。"
              no="7"
            />
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-order/7.png"
            />
            <HeaderFaq
              title="配布報告書<br/>
配布が完了しましたら、こちらから報告書のダウンロードが可能となります。"
              no="8"
            />
            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-order/8.png"
            />
          </main>
        </div>
        <!-- order management -->
        <!-- segment -->
        <div v-if="currentSection == 7">
          <h4 id="head3" style="font-size: 1.3rem; padding: 2rem 0">
            セグメント機能
          </h4>
          <main class="content">
            <HeaderFaq
              title="セグメント画面を開く<br/>
地図仮面から『セグメント』を押して世帯年収、家族構成、年齢の情報をMAP上に反映する事が可能です。"
              no="1"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-segment/1.png"
            />
            <HeaderFaq
              title="セグメント項目の選択<br/>
セグメント可能な項目が出てきますので、行いたいセグメントにチェックをいれてください。 ※2項目まで選択可能"
              no="2"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-segment/2.png"
            />
            <HeaderFaq
              title="セグメントデータ範囲の調整<br/>
地図上をクリック、または円のサイズを変更する事で、セグメントデータ(色が塗られるエリア)を反映するエリアの範囲の調整が可能です。
内容が問題無ければ『決定して戻る』ボタンを押してください。"
              no="3"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-segment/3.png"
            />
            <HeaderFaq
              title="エリアの選定<br/>
選択された項目によって、MAP上に色塗りがされておりますのでこちらを参考にエリアの選定が可能となります。"
              no="4"
            />
          </main>
        </div>
        <!-- segment -->

        <!-- term -->
        <div v-if="currentSection == 8">
          <h4 id="head3" style="font-size: 1.3rem; padding: 2rem 0">
            免責事項
          </h4>
          <main class="content">
            <div>
              <div class="section">
                <p class="font-bold">ポスティング</p>
                <!-- {{ getPlans2d() }} -->
                <p>配布エリア、部数、スケジュールについて</p>
                <p style="color: red">
                  エリア選択時に表示される配布部数は、当サービス独自の配布部数を示してお
                  り、選択エリアの全世帯への配布を保証するものではありません。
                </p>
                <p>
                  町丁目ごとの配布部数は、概算のため実際とは異なる可能性がございます。
                </p>
                <p>
                  配布先居住者のご意向による配布拒否、区画整理、住宅事情の変化、配布員確保、交通事情、天災・天候不良等の諸事情により選択エリア内の実配布数が配布見込数を下回った場合又は配布出来ないエリアが生じた場合、残数は、選択エリア近隣に配布されます。
                </p>
                <p>
                  単独の配布ではなく他社広告物と併せて配布を行います。情報誌への挟み込み、丁合を行う場合があります
                </p>
                <p>
                  選択された配布完了希望日どおりの配布をお約束することはできかねます。実際の完了予定日は、入稿データの審査後にご連絡致します。
                </p>
                <p>
                  完了予定日が確定後も決済期日までに決済の確認が行えない、期日までに指定
                  場所への納品が確認できない場合は完了予定日が変更となります。
                </p>

                <p class="font-bold">チラシ内容の審査について</p>
                <p>
                  以下の場合、お断りする場合があります <br />
                  • 法令、または公序良俗に反するもの<br />
                  • 各業界の広告ガイドラインに沿っていないもの<br />
                  • 内容が不明確なもの<br />
                  • 虚偽、誤認の恐れがあるもの<br />
                  • 意見広告<br />
                  • その他、当社が不適切と判断したもの<br />
                </p>
                <p>
                  チラシ内容の審査により、配布対応が不可となる場合や、ご希望のエリアに配
                  布出来ない場合、配布完了日が後ろ倒しになる場合がございます。また、審査
                  には数営業日を要する場合ががございますことを予めご了承下さいませ。
                  配布日に変更があった場合は審査後にお知らせします。
                </p>
                <p class="font-bold">その他注意事項</p>
                <p>
                  原稿審査審査完了後のキャンセルは、全額をキャンセル料として頂戴致しま
                  す。<br />
                  広告内容に因る部分が大きい為、必ずしも反響を保証するものではありません
                  当社判断で投函禁止の基準を設けておりますが、投函禁止の表記によっては投
                  函する場合があります。<br />
                  投函先対応にてお困りの際は当社までご連絡下さい。
                </p>
              </div>

              <!-- section 2 -->
              <div class="section">
                <p class="font-bold">新聞折込広告基準</p>
                <p>
                  チラシ内容の審査について <br /><br />
                  <a href="term_use" target="_blank" style="color: red"
                    >新聞折込広告基準</a
                  >に該当する広告、その他、当社オリコミサービスもしくは新聞<br />
                  販売店が不適切であると判断したものは、お断りする場合があります。<br />
                  以下の場合は、ご希望に沿えない場合がございますことを予めご了承下さいませ。<br />
                  ・チラシ内容の審査により、配布対応が不可またはご希望のエリアに配布出来な<br />
                  い場合、配布日が後ろ倒しになる場合がございます。審査には数営業日を要する<br />
                  場合がございますことを予めご了承下さいませ。<br />
                  ・新聞休刊日や選挙など、新聞発行本社の事情により新聞の発行がない場合<br />
                  ・交通事情や天災・荒天等の事情により、配布日に配布完了できない場合<br />
                  ・大規模災害や不可抗力による事故や事変が発生した場合
                  ※配布日に変更があった場合は、審査後にお知らせします。<br /><br />
                  その他注意事項<br />
                  ・チラシ内容審査後のキャンセルは、全額をキャンセル料として頂戴致します。<br />
                  ・円で選択した配布エリアのすべてに配布するわけではありません。あくまで配
                  布エリアの目安となります。<br />
                  ・配布対象となる新聞販売店は、指定頂いた円に含まれる面積で算出されます。
                  配布の区域指定はできません。<br />
                  ・新聞販売店の配達エリアによって、円外のエリアに配布される場合や、円内の<br />
                  エリアでも配布されない場合がございます。<br />
                  ・販売店の事情による配達エリアの変更、店舗間の合併、分割は予告なく実施さ
                  れます。また、朝刊ではなく夕刊で配布される地域もございます。<br />
                  ・チラシの折込作業上、機械や作業環境（湿度や静電気など）により、チラシが
                  複数枚折りこまれる、もしくは折込漏れがまれに発生する可能性がございます。
                  予めご了承ください。<br />
                  ・広告内容に因る部分が大きい為、必ずしも反響を保証するものではありません。<br />
                </p>
                <!-- <p>
                  日本新聞協会の示した「新聞折込広告基準」に準拠し、次のような折込広告は取り扱いません。
                </p>
                <p>
                  1.責任の所在および内容が不明確な広告
                  広告主名、所在地名、連絡先が記載されていない広告。
                  広告の意味、目的が分からないもの。
                </p>
                <p>
                  2.虚偽または誤認されるおそれがある広告
                  「日本一」「世界一」など最高・最大級の表現、「確実に儲かる」「絶対にやせる」などの断定的表現を何の裏付けもなく使用した広告。
                  「二重価格表示広告」・「おとり広告」は、受けるべきでない。
                </p>
                <p>
                  3.公序良俗を乱す表現の広告
                  露骨な性表現、あるいは暴力や犯罪を肯定・礼賛する広告、麻薬・覚醒剤の使用を賛美したり、その他残虐な表現のある広告。
                </p>
                <p>
                  4.不動産広告
                  不動産広告の表示は、「宅地建物取引業法」などの関係法規、不動産公正取引協議会の「不動産の表示に関する公正競争規約」による。
                </p>
                <p>
                  5.求人広告
                  雇用主の名称・所在地・連絡先、企業の種類と就業する職種など必要な事項が表示されていない広告。
                  「男女雇用均等法」「雇用対策法」に準じたもの。
                  履歴書用紙付求人広告は、履歴書に本籍地・家族関係・宗教・支持政党など差別につながる可能性がある項目があるもの。
                  求人広告に見せかけて講習料をとったり、物品・書籍などを売りつけたりするのが目的である広告。
                </p>
                <p>
                  6.名誉毀損、プライバシーの侵害などのおそれがある広告
                  広告表現中において名誉毀損・プライバシーの侵害・信用毀損・業務妨害となるおそれがあるもの。
                </p>
                <p>
                  7.選挙運動ビラなど<br />
                  選挙運動のための折込広告は、「公職選挙法」の要件を備えたもの以外は配布できない。
                  特に事前運動とみなされるおそれのある広告は、十分な注意が必要である。
                </p>
                <p>
                  8.弁護士の広告<br />
                  弁護士および外国特別会員の業務広告は、日本弁護士連合会の「弁護士の業務広告に関する規程」「外国特別会員の業務広告に関する規程」により定められた範囲内でなければ広告できない。
                </p>
                <p>
                  9.医療関係の広告<br />
                  医業・歯科医業・病院・診療所・助産所などの広告は、医療法に定められた事項以外は広告できない。
                  あん摩業・マッサージ業・柔道整復業などについても関連法規に定められた事項以外は広告できない。
                </p>
                <p>
                  10.医薬品の広告<br />
                  医薬品・医薬部外品・化粧品・医療用具・特定疾病用の医薬品・承認前の医薬品などの広告は、「医薬品等適正広告基準」の範囲内でなければ広告できない。
                </p>
                <p>
                  11.健康食品の広告<br />
                  健康食品の広告は、医薬品的な効能・効果を表示できない。
                </p>
                <p>
                  12.エステティックの広告<br />
                  美顔・痩身などエステ関連広告については、「特定商取引法」で誇大広告の禁止が定められている。〈例〉安全、完璧、日本一、業界一、業界初、絶対、永久、永遠、治療、治すなど。
                </p>
                <p>
                  13.金融関係の広告<br />
                  消費者金融広告などの貸金業の広告では、「貸金業の規則等に関する法律」で利率や登録番号など必要な表示事項を記載するように定められている。貸付条件については、誇大広告は禁止されている。
                  抵当証券業、投資顧問業、金融先物取引業などの広告については関連法規によって虚偽誇大、誤認期待の表現を禁止している。（抵当証券法・投資顧問業法など）
                </p>
                <p>
                  14.個人情報取扱事業者の広告 <br />
                  個人情報保護法により義務づけられる内容が不明確なもの、記載のないもの。（利用目的・利用範囲など）
                </p>
                <p>
                  15.その他 <br />
                  公序良俗に反したり、反社会的な表現の広告、誹謗中傷の恐れのある広告、あるいは迷信などに頼る非科学的な広告。
                  その他、独占禁止法、景品表示法、関係告示、規約に反するもの。
                  上記の他、弊社もしくは新聞販売店が不適切であると判断した場合は、物品受領後であっても新聞折込をお断りする場合がありますので予めご了承ください。
                </p> -->
              </div>
              <!-- section 3 -->
              <div class="section">
                <p class="font-bold">DSP配信</p>
                <p>
                  1.
                  発注者は、本業務に係る広告の内容(適法性・真実性・正確性・第三者の権利の非侵害等)について責任を負い、第三者が、
                  配信された広告の内容に起因する損害賠償請求その他のクレーム(以下「クレーム等」という。)を当社に行った場合、
                  発注者は自己の責任と費用で当該クレーム等を処理するものとし、また、クレーム等によって当社が損害を被った場合、
                  当該損害（弁護士費用を含む。）を賠償するもの致します。ただし、当社に故意又は重過失がある場合はこの限りでは
                  ございません。
                </p>
                <p>
                  2.
                  発注者は当社が提供するタグの利用に際して、タグを設置するウェブサイトのド
                  メイン所有者から利用許諾を得るもの致します。発注者は、当該利用において発生した損害及び当事者間のその他問題に
                  ついて、自らの責任で解決するものとし、当社は一切の責任を負いません。
                </p>
                <p>
                  3.
                  当社は、本業務を行うにあたり、発注者から提示された予算を完全に消化することを保証致しません（実費用に基づく請求となります）
                </p>
              </div>
            </div>
          </main>
        </div>
        <!-- term -->
        <!-- term -->
        <div v-if="currentSection == 10">
          <h4 id="head3" style="font-size: 1.3rem; padding: 2rem 0">
            見積もり条件検索
          </h4>
          <p>以前に作成したエリア情報から再編集が可能となる機能です</p>
          <main class="content">
            <HeaderFaq
              title="エリアの作成などを行ったが今回発注はせず、次回に再度編集を行いたい場合は『見積条件の保存』ボタンを押してから画面を閉じてください。"
              no="1"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-retrival/1.png"
            />
            <HeaderFaq
              title="再編集を行いたい場合は『見積条件の呼出』ボタンを押してください。"
              no="2"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-retrival/2.png"
            />
            <HeaderFaq
              title="過去に保存を行った見積条件が出てきます。
画面右上の 始まり と 終わり の部分に日付を選択する事で、
見積条件を保存した日にちから検索を行う事も可能です。"
              no="3"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-retrival/3.png"
            />
            <HeaderFaq
              title="『読み込み』ボタンを押すと以前に編集していた情報を呼びだすことができて、
再編集が可能となります。"
              no="4"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-retrival/4.png"
            />
            <HeaderFaq
              title="※見積条件の保存を行っていなくても、一度発注を行った商品であれば、注文の管理画面から『この注文情報を用いて再注文』を押すことで再編集、再発注が可能です。"
              no="5"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-retrival/5.png"
            />
          </main>
        </div>
        <!-- term -->
        <div v-if="currentSection == 9">
          <h4 id="head3" style="font-size: 1.3rem; padding: 2rem 0">
            一括見積もり
          </h4>

          <main class="content">
            <p>
              同時に複数商圏の作成を行う事が可能です。
              CSVデータから中心住所をアップする事も可能です。
            </p>
            
            <HeaderFaq
                title="「一括見積もり」ボタンをクリックして、一括注文の作成を開始してください。"
                no="1"
            />
            <img style="padding-bottom: 1rem" src="../assets/flow-bulk-new/1.png" />

            <HeaderFaq
                title="版の種類の選択"
                no="2"
            />
            <p>全国共通版、全商圏別版、商圏毎で版選択 の3つから選択可能です。
              詳細は『？』をクリックして確認をお願いします。</p>
            <p>
              
            </p>
            <img style="padding-bottom: 1rem" src="../assets/flow-bulk-new/2.png" />

            <HeaderFaq
                title="商圏の中心点を作成"
                no="3"
            />
            <p>作成したい箇所で右クリックを押すと商圏の中心点が作成されます。
              左側にテキスト記入欄が作成されますので商圏名を入力してください。</p>
            <p>※CSVデータを使用し一気に中心点を作成したい場合は
              <a @click="goTo8ThImageBulk" href="#">⑧へ移行</a></p>
              
            <img style="padding-bottom: 1rem" src="../assets/flow-bulk-new/3.png" />
            
            <p>上記を必要な数だけ繰り返し作業してください。</p>
              
            <img style="padding-bottom: 1rem" src="../assets/flow-bulk-new/4.png" />

            <HeaderFaq
                title="エリア選定の条件設定。"
                no="4"
                class="4-image-bulk"
            />

            <p>部数を設定では、各商圏の中心から、設定された部数を目安にエリアを作成します。</p>
            <p>半径を設定では、各商圏の中心から、設定された半径を目安にエリアを作成します。</p>

            <img style="padding-bottom: 1rem" src="../assets/flow-bulk-new/5.png" />

            <HeaderFaq
                title="配布(印刷)条件の設定"
                no="5"
            />

            <p>配布期間、配布方法、サイズ等、条件を選択してください。</p>
            <p>選択が完了したら『一括見積』ボタンを押してください。</p>

            <img style="padding-bottom: 1rem" src="../assets/flow-bulk-new/6.png" />
            <img style="padding-bottom: 1rem" src="../assets/flow-bulk-new/7.png" />

            <HeaderFaq
                title="エリアの微調整"
                no="6"
            />
            <p>中心点をクリックする事でエリアの確認と修正を行う事が可能でしょう。
              確認、修正が完了したら、右下の『更新』ボタンをクリックしてください。
              ※配布完了予定日やサイズなど、条件の修正を行った場合は、再度『一括見積』ボタンを押す必要がございます。　この場合、配布エリアも再度設定されてしまいますのでご注意ください。
            </p>

            <img style="padding-bottom: 1rem" src="../assets/flow-bulk-new/8.png" />

            <HeaderFaq
                title="カートへ移行"
                no="7"
            />
            <p>各作業が完了しましたら『カートへ入れる』ボタンをクリックしカート内へ進んでください。</p>
            <img style="padding-bottom: 1rem" src="../assets/flow-bulk-new/9.png" />
            <div class="gray-line" />
            <br/>
            <br/>
            <p>CSVデータを使用し一気に中心点を作成する方法</p>

            <HeaderFaq
                title="フォーマットのダウンロード"
                no="8"
                class="8-image-bulk"
            />
            <p>『ダウンロード』ボタンを押してアップ用のCSVデータをダウンロードしてください。</p>
            <img style="padding-bottom: 1rem" src="../assets/flow-bulk-new/10.png" />

            <HeaderFaq
                title="ファイルの作成"
                no="9"
            />
            <p>フォーマットに沿ってCSVファイルに商圏名・都道府県・市区町村・住所を入力してください。</p>
            <p>※緯度・経度は空欄でも大丈夫ですが、入力するとより正確なポイントにて作成が可能です。</p>
            <img style="padding-bottom: 1rem" src="../assets/flow-bulk-new/11.png" />

            <HeaderFaq
                title="アップロード"
                no="10"
            />
            <p>作成したCSVファイルをアップロードしてください。</p>
            <p>アップが完了しましたら上記
              <a href="#" @click="goTo4thImageBulk">
                ④～⑦
              </a>
              の作業を進めてください。</p>
            <img style="padding-bottom: 1rem" src="../assets/flow-bulk-new/12.png" />

          </main>
          
          <!-- <h4 id="head3" style="font-size: 1.3rem; padding: 2rem 0">
            一括見積もり
          </h4>
          <main class="content">
            <HeaderFaq
              title="「一括見積もり」ボタンをクリックして、一括注文の作成を開始してください。"
              no="1"
            />

            <img style="padding-bottom: 1rem" src="../assets/flow-bulk/1.png" />
            <HeaderFaq
              title="アイコンのゴミ箱ボタンをクリックすることで、選択されているエリアを削除することができます。"
              no="2"
            />

            <img style="padding-bottom: 1rem" src="../assets/flow-bulk/2.png" />
            <HeaderFaq
              title="選択したエリアをドラッグして移動したり、地図上で右クリックして新しいエリアを作成することもできます。"
              no="3"
            />

            <img style="padding-bottom: 1rem" src="../assets/flow-bulk/3.png" />
            <HeaderFaq
              title="データが保存されていることを確認してください。赤色はデータがまだ保存されていないことを意味し、黒色はデータが保存されていることを意味します。"
              no="4"
            />

            <img style="padding-bottom: 1rem" src="../assets/flow-bulk/4.png" />
            <HeaderFaq
              title="データを保存するには、「保存」ボタンを押してデータを保存できます。"
              no="5"
            />

            <img style="padding-bottom: 1rem" src="../assets/flow-bulk/5.png" />
            <HeaderFaq
              title="次に、以下のフィールドに必要なデータを入力します。"
              no="6"
            />

            <img style="padding-bottom: 1rem" src="../assets/flow-bulk/6.png" />
            <HeaderFaq
              title="「一括見積」ボタンをクリックして、事前に選択されたエリアの見積もりを表示し、その後、見積もりの総計を計算します。"
              no="7"
            />

            <img style="padding-bottom: 1rem" src="../assets/flow-bulk/7.png" />
            <HeaderFaq title="詳細情報は見積もり欄で確認できます。" no="8" />

            <img style="padding-bottom: 1rem" src="../assets/flow-bulk/8.png" />
            <HeaderFaq
              title="その後、「カートへ入れる」ボタンを押して、注文をカートに追加することができます。"
              no="9"
            />

            <img style="padding-bottom: 1rem" src="../assets/flow-bulk/9.png" />
            <HeaderFaq
              title="ダウンロードボタンを押せば、一括でデータをダウンロードすることもできる。"
              no="10"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-bulk/10.png"
            />
            <HeaderFaq
              title="一括データをダウンロードした後、csvドキュメントを開くことができます。"
              no="11"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-bulk/11.png"
            />
            <HeaderFaq title="1つ目は店舗名です。" no="12" />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-bulk/12.png"
            />
            <HeaderFaq title="2つ目は州／県である。" no="13" />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-bulk/13.png"
            />
            <HeaderFaq title="3つ目は都市である。" no="14" />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-bulk/14.png"
            />
            <HeaderFaq title="4つ目は住所である。 " no="15" />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-bulk/15.png"
            />
            <HeaderFaq title="5番目は緯度座標である。" no="16" />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-bulk/16.png"
            />
            <HeaderFaq title="そして6番目は経度座標である" no="17" />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-bulk/17.png"
            />
            <HeaderFaq
              title="また、マップを介さずに、csv文書で一括注文データを直接編集して一括注文することもできる。"
              no="18"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-bulk/18.png"
            />
            <HeaderFaq
              title="その後、csv文書で編集されたデータは、アップロード一括注文ボタンを押してアップロードすることができます。"
              no="19"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-bulk/21.png"
            />
            <HeaderFaq
              title="データがアップロードされた後、未保存のストアデータは赤く表示されます。"
              no="20"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-bulk/19.png"
            />
            <HeaderFaq
              title="アップロード後、保存ボタンを押してデータを保存します。"
              no="21"
            />

            <img
              style="padding-bottom: 1rem"
              src="../assets/flow-bulk/20.png"
            />
          </main> -->
        </div>
        <div v-if="currentSection == 12">
          <h4 id="head3" style="font-size: 1.3rem; padding: 2rem 0">
            印刷データ入稿時の注意
          </h4>
          <p>入稿時の注意</p>
          <main class="content">
            <HeaderFaq
              title="<strong>フォントはすべてアウトライン化してください。</strong> "
              no="1"
            />
            <p>
              文字のデザイン（明朝体、ゴシック体など）の変更はフォント（書体）を指定することにより行います。
              完成したデータを別のパソコンで開いた時に、同じフォントが無ければ正確に画面に表示する事はできません。
              また、使用しているフォントやソフトウェアにより全く読めない記号の羅列のように文字が化けてしまう場合もあり
              ます。<br />
              Illustrator、InDesign、QuarkXPress
              などのソフトウェアでは、フォントを図形に変換する
              <strong>「アウトライン化（グラフ ィックス化）」</strong
              >という機能があります。<br />図形に変換されていれば、フォントが有るか無いかを気にする必要はありません。
            </p>

            <img
              style="padding-bottom: 1rem; width: max-content; max-width: 100%"
              src="../assets/flow-guide/1.png"
            />
            <p>
              PDF データでご入稿する場合、エンベッドしていただく必要があります。
              エンベッドとは、データの中にフォント情報を埋め込むことです。
              エンベッドされていればフォントが無い環境でもフォントのデザインを生かした状態で印刷する事ができます。
              InDesign、QuarkXPress などアウトライン化するより、PDF
              にしてご入稿いただく方が後々の修正等が楽になる場合 があります。
            </p>
            <HeaderFaq title="<strong>画像の解像度について</strong>" no="2" />
            <p>
              配置画像の解像度は 350dpi 以上を推奨しています。<br />
              「解像度」は、デジタル画像のきめの細かさを指しています。<br />
              単位は ppi ： pixel/inch、dpi ： dot/inch などで表し、1
              インチあたりの点の数を表しています。<br />
              数値が高いほど密度が高くなり、きめが細かいという事になります。<br />
              印刷の際に必要な解像度は仕上がりのカラーとイメージにより決まってきます。
            </p>

            <img
              style="padding-bottom: 1rem; width: max-content; max-width: 100%"
              src="../assets/flow-guide/2.png"
            />
            <p>
              インターネットなどの画像は、72dpi や 96dpi
              あれば綺麗に見えますが、印刷では上の表のような解像度が目安とな
              ります。<br />
              インターネットなどの画像は 5 分の 1
              程度しか密度がないため印刷すると粗くなってしまいます。デジタルの画像やデジタルカメラの画像は作った時（撮影した時）に設定した
              pixel（dot）数になります。<br />
              拡大した場合は画像のサイズは大きくなるが、pixel（dot）の数が変わらないため、解像度が低くなり粗くなります。<br />
              使用したいサイズのときに必要な解像度になっているか注意が必要です。
            </p>
            <HeaderFaq
              title="<strong>AI データにて入稿時の画像に関して</strong> "
              no="3"
            />
            <p>
              AI
              データでご入稿の場合は、画像を全て埋め込んでいただくか、パッケージ機能にてリンク画像全てをご入稿くださ
              い。<br />
              この機能は、Adobe Illustrator CS6、CC
              およびそれ以降で使用できます。<br />
              フォント（中国語、韓国語、日本語を除く）やリンクグラフィックなど、作成したドキュメントに使用されているフ
              ァイルを収集して、ハンドオフに必要なファイルを簡単に揃えることができます。ファイルをパッケージ化すると、
              Illustrator
              ドキュメント、必要なフォント、リンクグラフィック、パッケージレポートが含まれたフォルダーが作成
              されます。パッケージレポートには、パッケージされたファイルに関する情報が含まれ、テキストファイルとして保
              存されます。
            </p>
            <ol style="">
              <li>
                <p><strong>ファイル／パッケージを選択します。</strong></p>
                <img
                  style="padding: 1rem 0; width: max-content; max-width: 100%"
                  src="../assets/flow-guide/3.png"
                />
                <p>パッケージダイアログボックス</p>
              </li>
              <li>
                <strong>フォルダーおよびファイルの位置を指定します。</strong>
                <p style="padding-top: 1rem">
                  <strong>場所</strong> <br />
                  パッケージフォルダーを作成する場所を指定します。
                </p>
                <p>
                  <strong>フォルダー名</strong> <br />
                  パッケージの名前を指定します。デフォルトでは、フォルダー名は
                  Illustrator ドキュメントの名前が付けら れます。
                </p>
              </li>
              <li>
                <strong>次のオプションを指定します</strong>
                <p style="padding-top: 1rem">
                  <strong>リンクをコピー</strong> <br />
                  リンクグラフィックおよびリンクファイルをパッケージフォルダーにコピーします。
                </p>
                <p>
                  <strong>リンクを別のフォルダーに収集</strong> <br />
                  リンクフォルダーを作成して、すべてのリンクアセットをそのフォルダーに保存します。このオプションを
                  選択しない場合、.ai
                  ファイルと同じフォルダー内にアセットがコピーされます。
                </p>
                <p>
                  <strong
                    >ドキュメントで使用されているフォントをコピー（欧文フォントのみ）</strong
                  >
                  <br />
                  フォントファミリー全体ではなく、すべての必要なフォントファイルがコピーされます。
                </p>
                <p>
                  <strong>注意：</strong> <br />
                  フォントをパッケージする際、警告が表示されます。フォントのコピーに関する許可があるかどうかを確認
                  するには、ライセンス許諾契約書をご覧ください。
                </p>
                <p>
                  <strong>レポートを作成</strong> <br />
                  パッケージファイルに付随する概要レポートを作成します。このレポートには、特色のオブジェクト、すべ
                  ての使用フォントおよび所在不明のフォント、所在不明のリンクに関する概要とすべてのリンク画像または
                  埋め込み画像の詳細が含まれます。
                </p>
              </li>
              <li>
                <strong
                  >「パッケージ」をクリックします。次のフォルダー構造が作成されます。各アセットはそれぞれのフォルダ
                  ーに配置されます。</strong
                >
                <img
                  style="padding: 1rem 0; width: max-content; max-width: 100%"
                  src="../assets/flow-guide/4.png"
                />
                <p>パッケージフォルダーの構造</p>
              </li>
            </ol>

            <HeaderFaq
              title="<strong>罫線の太さ（ポイント数）について</strong> "
              no="4"
            />
            <p>
              罫線は 0.3pt（0.1ｍｍ）以上の線幅を設定してください。<br />
              これより細い線は印刷時にかすれたり消えてしまう場合があります。
            </p>
            <ul>
              <li>
                Adobe Illustrator の透明効果を使用している場合、
                「効果」メニューにある「ドキュメントの
                ラスタライズ効果設定」がスクリーン（72dpi）になっていると効果が粗く表示・印刷されま
                す。解像度は高解像度（300dpi）か、その他で任意の適正な数値（350dpi
                以上）に設定して ください。
              </li>
            </ul>
            <HeaderFaq
              title="<strong>PDF のセキュリティ解除について</strong> "
              no="5"
            />
            <p>
              PDF のセキュリティ（パスワード）は全て解除してご入稿ください。<br />
              セキュリティは、開いている PDF
              から削除することができます。ただし、そのための権限が必要になります。PDF
              がサーバーベースのセキュリティポリシーで保護されている場合、その
              PDF を変更できるのは、ポリシーの作成者
              またはサーバー管理者だけです。
            </p>

            <ol>
              <li>
                PDF を開いてから、すべてのツール／PDF
                を保護／セキュリティプロパティを選択します。
              </li>
              <li>
                文書のプロパティウィンドウで、
                「セキュリティ」タブを選択してから、
                「設定を変更」を選択します。
              </li>
              <li>
                使用できるオプションは、文書に付加されているパスワードセキュリティのタイプによって異なります。
              </li>
            </ol>

            <ul>
              <li>
                文書に文書を開くパスワードのみが設定されている場合は、
                「文書を開くときにパスワードが必要」オプションの
                選択を解除してから、 「OK」をクリックして文書から削除します。
              </li>
              <li>
                文書に権限パスワードが設定されている場合は、「文書の印刷および編集を制限」オプションの選択を解除しま
                す。メッセージが表示されたら、「パスワードを入力」ボックスにパスワードを入力し、
                「OK」を選択します。 「OK」 をもう一度選択して操作を確定します。
              </li>
            </ul>

            <HeaderFaq
              title="<strong>PDF で印刷ができない機能について</strong> "
              no="6"
            />
            <p>
              PDF
              の注釈機能、フォーム機能は印刷できませんので使用しないでください。<br /><br />
              <strong>コメント（注釈）の削除</strong> <br />
              追加したコメント（注釈）を削除するには、選択ツールでノートアイコンをクリックして、Delete
              キーを押します。
              または、ノートアイコンを右クリックして、オプションメニューから「削除」を選択しても削除できます。
            </p>

            <img
              style="padding-bottom: 1rem; width: max-content; max-width: 100%"
              src="../assets/flow-guide/5.png"
            />
            <p>
              <strong>フォームフィールドの削除</strong>
            </p>
            <ol>
              <li>
                フォーム編集モードで作業をしていない場合は、すべてのツールパネルから「フォームを準備」を選択します。
              </li>
              <li>
                右パネルの「フィールド」またはページビューで、削除するフォームフィールドを選択します。
              </li>
              <li>
                コンテキストメニューから、「削除」を選択するか、編集／削除を選択します。
              </li>
            </ol>

            <HeaderFaq
              title="<strong>印刷の向き・裏表について</strong> "
              no="7"
            />
            <p>
              印刷の向き・表裏指定 <br />
              特別に「天（上） 」と「地（下）」の指示がない場合、
              データの上部を「天」 、下部を「地」として進めます。<br />トンボの外側や、テキスト、仕上がりイメージ画像等でお知らせください。<br />
              両面印刷をする場合は、
              「表」と「裏」が分かるようにご指示願います。
            </p>
            <img
              style="padding-bottom: 1rem; width: max-content; max-width: 100%"
              src="../assets/flow-guide/6.png"
            />
            <p>
              複数ページ指定 <br />
              特別に指示がなく一つのデータで複数ページがある場合は奇数ページを「表」
              、偶数ページを「裏」とします。<br />
              複数のページを一つのページ内に作成することはしないでください。必ず、データで分けるか、ページで分けて作成
              してください。<br />
              中綴じ冊子や無線綴じ冊子をする場合は、トンボの外側や、データの名前などでページが分かるようにしてくださ
              い。
            </p>
            <img
              style="padding-bottom: 1rem; width: max-content; max-width: 100%"
              src="../assets/flow-guide/7.png"
            />
            <p>
              表と裏の向き <br />
              データの表と裏の向きが同じ場合は、表裏のデータの上同士が合うように両面印刷します。
            </p>
            <img
              style="padding-bottom: 1rem; width: max-content; max-width: 100%"
              src="../assets/flow-guide/8.png"
            />
            <p>
              向きが違う場合、向きを合わせるためには、右回りか左回りか 2
              パターンありますが、
              特別な指示が無い限り、表を基準として裏面を右回り（時計回り）に回転で印刷させていただきます。
            </p>
            <p>
              表面が縦向き、裏面が横向きの場合 <br />
              裏面を時計回りに回転させて、用紙の向きを合わせて印刷します
            </p>
            <img
              style="padding-bottom: 1rem; width: max-content; max-width: 100%"
              src="../assets/flow-guide/9.png"
            />
            <p>
              表面が横向き、裏面が縦向きの場合 <br />
              裏面を時計回りに回転させて、用紙の向きを合わせて印刷します。
            </p>
            <img
              style="padding-bottom: 1rem; width: max-content; max-width: 100%"
              src="../assets/flow-guide/10.png"
            />

            <HeaderFaq title="<strong>折り加工について</strong> " no="8" />
            <p>
              チラシ・フライヤーに折り加工をする場合には、折り方をご指定ください。<br />
              折り加工はオプション対応となりますので、別料金と加工期間が 1
              日必要になります。<br /><br />
              折加工の仕様は印刷用データの中や、文字データなどでご指定ください。<br />
              折る位置の数値や、折る方向（山折り・谷折り）
              、表紙の位置（折った後に一番上の面）などを お知らせください。<br /><br />
              <strong>2 つ折り(センター折り)</strong>
              <img
                style="
                  padding-bottom: 1rem;
                  width: max-content;
                  max-width: 100%;
                "
                src="../assets/flow-guide/11.png"
              />
              長い辺を中央から直角に 2
              つ折りする、標準の折り方です。仕上がりサイズが 2 分の 1
              になります。<br />
              1 枚の用紙を 4 ページに見せることができます。<br />
              表面が外側に裏面が内側になるように折っていきます。<br />
              ※対応サイズ参考 〇〇～〇〇（紙の斤量 00 ㎏まで）<br />
              ※用紙の種類により、対応できない場合もございます。詳しくは折り加工
              サイズ別用紙対応表でご確認ください。<br />
              ※①表面、②裏面の判断がつかない場合は、進行不可となります。必ずご指示くださいませ。<br /><br />
              <strong>十字折り(センター四つ折り)</strong>
              <img
                style="
                  padding-bottom: 1rem;
                  width: max-content;
                  max-width: 100%;
                "
                src="../assets/flow-guide/12.png"
              />
              紙面の中心点を起点に十字に折る折り方です。仕上がりサイズが 4 分の
              1 になります。<br />
              長い辺を半分に折り、折った後に長くなった辺を半分に折ります。<br />
              表面の半分が外側に、裏面が内側になるように折っていきます。<br />
              ※対応サイズ参考 〇〇～〇〇（紙の斤量 00 ㎏まで）<br />
              ※用紙の種類により、対応できない場合もございます。詳しくは折り加工
              サイズ別用紙対応表でご確認ください。<br />
              ※①表面、②裏面、③外側になる表面の半分の面の判断がつかない場合は、進行不可となります。必ずご指示くださ
              いませ。
            </p>
          </main>
        </div>
        <!-- term -->
      </section>
    </div>
  </div>
</template>
<script>
import { BIconChevronCompactRight } from "bootstrap-icons-vue";
import HeaderFaq from "../components/faq/HeaderFaq";
import "../styles/faq.css";
import Header from "../components/Header.vue";

export default {
  name: "FAQ",
  data() {
    return {
      mainContent: "",
      modal: false,
      currentSection: 1,
    };
  },
  components: {
    BIconChevronCompactRight,
    HeaderFaq,
    Header,
  },
  mounted() {
    if (window.innerWidth <= 768) {
      this.modal = true;
    }

    window.addEventListener("resize", this.adjustElements);
    const add = document.getElementById("main");
    const linka = document.getElementById("linka");
    const linkb = document.getElementById("linkb");
    const linkba = document.getElementById("linkba");
    const linkbyoff = document.getElementById("linkbyoff");
    const linkbb = document.getElementById("linkbb");
    const linkbc = document.getElementById("linkbc");
    const linkbd = document.getElementById("linkbd");
    const linkc = document.getElementById("linkc");
    const linkd = document.getElementById("linkd");
    const linke = document.getElementById("linke");
    const linkf = document.getElementById("linkf");
    const linkg = document.getElementById("linkg");
    const linkh = document.getElementById("linkh");
    const linkj = document.getElementById("linkj");

    linka.addEventListener("click", () => {
      this.$router.push("/term?section=1");

      this.modal = false;
      add.scrollTo({ behavior: "smooth", top: 0 });
      linka.classList.add("active");
      linkb.classList.remove("active");
      linkc.classList.remove("active");
      linkba.classList.remove("active");
      linkbyoff.classList.remove("active");
      linkbb.classList.remove("active");
      linkbc.classList.remove("active");
      linkd.classList.remove("active");
      linke.classList.remove("active");
      linkf.classList.remove("active");
      linkg.classList.remove("active");
      linkh.classList.remove("active");
      linkbd.classList.remove("active");
      linkj.classList.remove("active");
    });
    linkb.addEventListener("click", () => {
      this.$router.push("/term?section=2");
      this.modal = false;
      add.scrollTo({ behavior: "smooth", top: 0 });

      linka.classList.remove("active");
      linkb.classList.add("active");
      linkba.classList.add("active");
      linkbyoff.classList.remove("active");
      linkbb.classList.remove("active");
      linkbc.classList.remove("active");
      linkc.classList.remove("active");
      linkd.classList.remove("active");
      linke.classList.remove("active");
      linkf.classList.remove("active");
      linkg.classList.remove("active");
      linkh.classList.remove("active");
      linkbd.classList.remove("active");
      linkj.classList.remove("active");
    });
    linkba.addEventListener("click", () => {
      this.$router.push("/term?section=2");
      this.modal = false;
      add.scrollTo({ behavior: "smooth", top: 0 });

      linka.classList.remove("active");
      linkb.classList.add("active");
      linkba.classList.add("active");
      linkbyoff.classList.remove("active");
      linkbb.classList.remove("active");
      linkbc.classList.remove("active");
      linkc.classList.remove("active");
      linkd.classList.remove("active");
      linke.classList.remove("active");
      linkf.classList.remove("active");
      linkg.classList.remove("active");
      linkh.classList.remove("active");
      linkbd.classList.remove("active");
      linkj.classList.remove("active");
    });
    linkbyoff.addEventListener("click", () => {
      this.$router.push("/term?section=15");
      this.modal = false;
      add.scrollTo({ behavior: "smooth", top: 0 });

      linka.classList.remove("active");
      linkb.classList.add("active");
      linkba.classList.remove("active");
      linkbyoff.classList.add("active");
      linkbb.classList.remove("active");
      linkbc.classList.remove("active");
      linkc.classList.remove("active");
      linkd.classList.remove("active");
      linke.classList.remove("active");
      linkf.classList.remove("active");
      linkg.classList.remove("active");
      linkh.classList.remove("active");
      linkbd.classList.remove("active");
      linkj.classList.remove("active");
    });
    linkbb.addEventListener("click", () => {
      this.$router.push("/term?section=3");
      add.scrollTo({ behavior: "smooth", top: 0 });
      this.modal = false;

      linka.classList.remove("active");
      linkb.classList.add("active");
      linkbyoff.classList.remove("active");
      linkba.classList.remove("active");
      linkbb.classList.add("active");
      linkbc.classList.remove("active");
      linkc.classList.remove("active");
      linkd.classList.remove("active");
      linke.classList.remove("active");
      linkf.classList.remove("active");
      linkg.classList.remove("active");
      linkh.classList.remove("active");
      linkj.classList.remove("active");
      linkbd.classList.remove("active");
    });
    linkbc.addEventListener("click", () => {
      this.$router.push("/term?section=4");
      add.scrollTo({ behavior: "smooth", top: 0 });
      this.modal = false;

      linka.classList.remove("active");
      linkb.classList.add("active");
      linkbyoff.classList.remove("active");
      linkba.classList.remove("active");
      linkbb.classList.remove("active");
      linkbc.classList.add("active");
      linkc.classList.remove("active");
      linkd.classList.remove("active");
      linkj.classList.remove("active");
      linke.classList.remove("active");
      linkf.classList.remove("active");
      linkg.classList.remove("active");
      linkh.classList.remove("active");
      linkbd.classList.remove("active");
    });
    linkbd.addEventListener("click", () => {
      this.$router.push("/term?section=11");
      add.scrollTo({ behavior: "smooth", top: 0 });
      this.modal = false;

      linka.classList.remove("active");
      linkb.classList.add("active");
      linkbyoff.classList.remove("active");
      linkba.classList.remove("active");
      linkbb.classList.remove("active");
      linkbc.classList.remove("active");
      linkbd.classList.add("active");
      linkc.classList.remove("active");
      linkd.classList.remove("active");
      linke.classList.remove("active");
      linkf.classList.remove("active");
      linkg.classList.remove("active");
      linkj.classList.remove("active");
      linkh.classList.remove("active");
    });
    linkc.addEventListener("click", () => {
      this.$router.push("/term?section=5");
      add.scrollTo({ behavior: "smooth", top: 0 });
      this.modal = false;

      linka.classList.remove("active");
      linkb.classList.remove("active");
      linkbyoff.classList.remove("active");
      linkba.classList.remove("active");
      linkbb.classList.remove("active");
      linkbc.classList.remove("active");
      linkbd.classList.remove("active");
      linkc.classList.add("active");
      linkd.classList.remove("active");
      linke.classList.remove("active");
      linkf.classList.remove("active");
      linkg.classList.remove("active");
      linkj.classList.remove("active");
      linkh.classList.remove("active");
    });
    linkd.addEventListener("click", () => {
      this.$router.push("/term?section=6");
      add.scrollTo({ behavior: "smooth", top: 0 });
      this.modal = false;

      linka.classList.remove("active");
      linkb.classList.remove("active");
      linkbyoff.classList.remove("active");
      linkba.classList.remove("active");
      linkbb.classList.remove("active");
      linkbc.classList.remove("active");
      linkj.classList.remove("active");
      linkbd.classList.remove("active");
      linkc.classList.remove("active");
      linkd.classList.add("active");
      linke.classList.remove("active");
      linkf.classList.remove("active");
      linkg.classList.remove("active");
      linkh.classList.remove("active");
    });
    linke.addEventListener("click", () => {
      this.$router.push("/term?section=7");
      add.scrollTo({ behavior: "smooth", top: 0 });
      this.modal = false;

      linka.classList.remove("active");
      linkb.classList.remove("active");
      linkbyoff.classList.remove("active");
      linkba.classList.remove("active");
      linkbd.classList.remove("active");
      linkbb.classList.remove("active");
      linkbc.classList.remove("active");
      linkc.classList.remove("active");
      linkj.classList.remove("active");
      linkd.classList.remove("active");
      linke.classList.add("active");
      linkf.classList.remove("active");
      linkg.classList.remove("active");
      linkh.classList.remove("active");
    });
    linkf.addEventListener("click", () => {
      this.$router.push("/term?section=8");
      add.scrollTo({ behavior: "smooth", top: 0 });
      this.modal = false;

      linka.classList.remove("active");
      linkb.classList.remove("active");
      linkbyoff.classList.remove("active");
      linkba.classList.remove("active");
      linkj.classList.remove("active");
      linkbb.classList.remove("active");
      linkbd.classList.remove("active");
      linkbc.classList.remove("active");
      linkc.classList.remove("active");
      linkd.classList.remove("active");
      linke.classList.remove("active");
      linkf.classList.add("active");
      linkg.classList.remove("active");
      linkh.classList.remove("active");
    });
    linkg.addEventListener("click", () => {
      this.$router.push("/term?section=9");
      add.scrollTo({ behavior: "smooth", top: 0 });
      this.modal = false;

      linka.classList.remove("active");
      linkb.classList.remove("active");
      linkbyoff.classList.remove("active");
      linkba.classList.remove("active");
      linkbb.classList.remove("active");
      linkbc.classList.remove("active");
      linkc.classList.remove("active");
      linkj.classList.remove("active");
      linkbd.classList.remove("active");
      linkd.classList.remove("active");
      linke.classList.remove("active");
      linkf.classList.remove("active");
      linkg.classList.add("active");
      linkh.classList.remove("active");
    });
    linkh.addEventListener("click", () => {
      this.$router.push("/term?section=10");
      add.scrollTo({ behavior: "smooth", top: 0 });
      this.modal = false;

      linka.classList.remove("active");
      linkb.classList.remove("active");
      linkbyoff.classList.remove("active");
      linkba.classList.remove("active");
      linkbb.classList.remove("active");
      linkbc.classList.remove("active");
      linkc.classList.remove("active");
      linkd.classList.remove("active");
      linkj.classList.remove("active");
      linkbd.classList.remove("active");
      linke.classList.remove("active");
      linkf.classList.remove("active");
      linkg.classList.remove("active");
      linkh.classList.add("active");
    });
    linkj.addEventListener("click", () => {
      this.$router.push("/term?section=12");
      add.scrollTo({ behavior: "smooth", top: 0 });
      this.modal = false;

      linka.classList.remove("active");
      linkb.classList.remove("active");
      linkbyoff.classList.remove("active");
      linkba.classList.remove("active");
      linkbb.classList.remove("active");
      linkbc.classList.remove("active");
      linkc.classList.remove("active");
      linkd.classList.remove("active");
      linkj.classList.add("active");
      linkbd.classList.remove("active");
      linke.classList.remove("active");
      linkf.classList.remove("active");
      linkg.classList.remove("active");
      linkh.classList.remove("active");
    });
  },
  updated() {
    if (this.$route.query.section === undefined) {
      this.currentSection = 1;
    } else {
      this.currentSection = this.$route.query.section;
    }

    const add = document.getElementById("main");
    const linka = document.getElementById("linka");
    const linkb = document.getElementById("linkb");
    const linkba = document.getElementById("linkba");
    const linkbyoff = document.getElementById("linkbyoff");
    const linkbb = document.getElementById("linkbb");
    const linkbc = document.getElementById("linkbc");
    const linkbd = document.getElementById("linkbd");
    const linkc = document.getElementById("linkc");
    const linkd = document.getElementById("linkd");
    const linke = document.getElementById("linke");
    const linkf = document.getElementById("linkf");
    const linkg = document.getElementById("linkg");
    const linkh = document.getElementById("linkh");
    const linkj = document.getElementById("linkj");

    linka.addEventListener("click", () => {
      this.$router.push("/term?section=1");

      this.modal = false;
      add.scrollTo({ behavior: "smooth", top: 0 });
      linka.classList.add("active");
      linkb.classList.remove("active");
      linkj.classList.remove("active");
      linkc.classList.remove("active");
      linkba.classList.remove("active");
      linkbyoff.classList.remove("active");
      linkbb.classList.remove("active");
      linkbc.classList.remove("active");
      linkd.classList.remove("active");
      linke.classList.remove("active");
      linkf.classList.remove("active");
      linkg.classList.remove("active");
      linkh.classList.remove("active");
    });
    linkb.addEventListener("click", () => {
      this.$router.push("/term?section=2");
      this.modal = false;
      add.scrollTo({ behavior: "smooth", top: 0 });

      linka.classList.remove("active");
      linkb.classList.add("active");
      linkba.classList.add("active");
      linkbyoff.classList.remove("active");
      linkbb.classList.remove("active");
      linkbc.classList.remove("active");
      linkc.classList.remove("active");
      linkd.classList.remove("active");
      linke.classList.remove("active");
      linkf.classList.remove("active");
      linkg.classList.remove("active");
      linkh.classList.remove("active");
      linkj.classList.remove("active");
    });
    linkba.addEventListener("click", () => {
      this.$router.push("/term?section=2");
      this.modal = false;
      add.scrollTo({ behavior: "smooth", top: 0 });

      linka.classList.remove("active");
      linkb.classList.add("active");
      linkba.classList.add("active");
      linkbyoff.classList.remove("active");
      linkbb.classList.remove("active");
      linkbc.classList.remove("active");
      linkc.classList.remove("active");
      linkd.classList.remove("active");
      linke.classList.remove("active");
      linkf.classList.remove("active");
      linkg.classList.remove("active");
      linkh.classList.remove("active");
      linkj.classList.remove("active");
    });
    linkbyoff.addEventListener("click", () => {
      this.$router.push("/term?section=15");
      this.modal = false;
      add.scrollTo({ behavior: "smooth", top: 0 });

      linka.classList.remove("active");
      linkb.classList.add("active");
      linkba.classList.remove("active");
      linkbyoff.classList.add("active");
      linkbb.classList.remove("active");
      linkbc.classList.remove("active");
      linkc.classList.remove("active");
      linkd.classList.remove("active");
      linke.classList.remove("active");
      linkf.classList.remove("active");
      linkg.classList.remove("active");
      linkh.classList.remove("active");
      linkj.classList.remove("active");
    });
    linkbb.addEventListener("click", () => {
      this.$router.push("/term?section=3");
      add.scrollTo({ behavior: "smooth", top: 0 });
      this.modal = false;

      linka.classList.remove("active");
      linkb.classList.add("active");
      linkba.classList.remove("active");
      linkbyoff.classList.remove("active");
      linkbb.classList.add("active");
      linkbc.classList.remove("active");
      linkc.classList.remove("active");
      linkd.classList.remove("active");
      linke.classList.remove("active");
      linkf.classList.remove("active");
      linkg.classList.remove("active");
      linkh.classList.remove("active");
      linkj.classList.remove("active");
    });
    linkbd.addEventListener("click", () => {
      this.$router.push("/term?section=11");
      add.scrollTo({ behavior: "smooth", top: 0 });
      this.modal = false;

      linka.classList.remove("active");
      linkb.classList.add("active");
      linkba.classList.remove("active");
      linkbyoff.classList.remove("active");
      linkbb.classList.remove("active");
      linkbc.classList.remove("active");
      linkbd.classList.add("active");
      linkc.classList.remove("active");
      linkd.classList.remove("active");
      linke.classList.remove("active");
      linkf.classList.remove("active");
      linkg.classList.remove("active");
      linkh.classList.remove("active");
      linkj.classList.remove("active");
    });
    linkbc.addEventListener("click", () => {
      this.$router.push("/term?section=4");
      add.scrollTo({ behavior: "smooth", top: 0 });
      this.modal = false;

      linka.classList.remove("active");
      linkb.classList.add("active");
      linkba.classList.remove("active");
      linkbyoff.classList.remove("active");
      linkbb.classList.remove("active");
      linkbc.classList.add("active");
      linkc.classList.remove("active");
      linkd.classList.remove("active");
      linke.classList.remove("active");
      linkf.classList.remove("active");
      linkg.classList.remove("active");
      linkh.classList.remove("active");
    });
    linkc.addEventListener("click", () => {
      this.$router.push("/term?section=5");
      add.scrollTo({ behavior: "smooth", top: 0 });
      this.modal = false;

      linka.classList.remove("active");
      linkb.classList.remove("active");
      linkba.classList.remove("active");
      linkbyoff.classList.remove("active");
      linkbb.classList.remove("active");
      linkc.classList.add("active");
      linkd.classList.remove("active");
      linke.classList.remove("active");
      linkf.classList.remove("active");
      linkg.classList.remove("active");
      linkh.classList.remove("active");
      linkj.classList.remove("active");
    });
    linkd.addEventListener("click", () => {
      this.$router.push("/term?section=6");
      add.scrollTo({ behavior: "smooth", top: 0 });
      this.modal = false;

      linka.classList.remove("active");
      linkb.classList.remove("active");
      linkba.classList.remove("active");
      linkbyoff.classList.remove("active");
      linkbb.classList.remove("active");
      linkc.classList.remove("active");
      linkd.classList.add("active");
      linke.classList.remove("active");
      linkf.classList.remove("active");
      linkg.classList.remove("active");
      linkh.classList.remove("active");
      linkj.classList.remove("active");
    });
    linke.addEventListener("click", () => {
      this.$router.push("/term?section=7");
      add.scrollTo({ behavior: "smooth", top: 0 });
      this.modal = false;

      linka.classList.remove("active");
      linkb.classList.remove("active");
      linkba.classList.remove("active");
      linkbyoff.classList.remove("active");
      linkbb.classList.remove("active");
      linkc.classList.remove("active");
      linkd.classList.remove("active");
      linke.classList.add("active");
      linkf.classList.remove("active");
      linkg.classList.remove("active");
      linkh.classList.remove("active");
      linkj.classList.remove("active");
    });
    linkf.addEventListener("click", () => {
      this.$router.push("/term?section=8");
      add.scrollTo({ behavior: "smooth", top: 0 });
      this.modal = false;

      linka.classList.remove("active");
      linkb.classList.remove("active");
      linkba.classList.remove("active");
      linkbyoff.classList.remove("active");
      linkbb.classList.remove("active");
      linkc.classList.remove("active");
      linkd.classList.remove("active");
      linkd.classList.remove("active");
      linke.classList.remove("active");
      linkf.classList.add("active");
      linkg.classList.remove("active");
      linkh.classList.remove("active");
      linkj.classList.remove("active");
    });
    linkg.addEventListener("click", () => {
      this.$router.push("/term?section=9");
      add.scrollTo({ behavior: "smooth", top: 0 });
      this.modal = false;

      linka.classList.remove("active");
      linkb.classList.remove("active");
      linkba.classList.remove("active");
      linkbyoff.classList.remove("active");
      linkbb.classList.remove("active");
      linkbc.classList.remove("active");
      linkc.classList.remove("active");
      linkd.classList.remove("active");
      linke.classList.remove("active");
      linkf.classList.remove("active");
      linkg.classList.add("active");
      linkh.classList.remove("active");
      linkj.classList.remove("active");
    });
    linkh.addEventListener("click", () => {
      this.$router.push("/term?section=10");
      add.scrollTo({ behavior: "smooth", top: 0 });
      this.modal = false;

      linka.classList.remove("active");
      linkb.classList.remove("active");
      linkba.classList.remove("active");
      linkbyoff.classList.remove("active");
      linkbb.classList.remove("active");
      linkbc.classList.remove("active");
      linkc.classList.remove("active");
      linkd.classList.remove("active");
      linke.classList.remove("active");
      linkf.classList.remove("active");
      linkg.classList.remove("active");
      linkh.classList.add("active");
      linkj.classList.remove("active");
    });
    linkj.addEventListener("click", () => {
      this.$router.push("/term?section=12");
      add.scrollTo({ behavior: "smooth", top: 0 });
      this.modal = false;

      linka.classList.remove("active");
      linkb.classList.remove("active");
      linkba.classList.remove("active");
      linkbyoff.classList.remove("active");
      linkbb.classList.remove("active");
      linkbc.classList.remove("active");
      linkc.classList.remove("active");
      linkd.classList.remove("active");
      linke.classList.remove("active");
      linkf.classList.remove("active");
      linkg.classList.remove("active");
      linkh.classList.remove("active");
      linkj.classList.add("active");
    });
  },
  methods: {
    goTo5thPage() {
      const add = document.getElementById("main");
      add.scrollTo({ behavior: "smooth", top: 0 });
      this.$router.push("/term?section=5");
      linka.classList.remove("active");
      linkb.classList.remove("active");
      linkba.classList.remove("active");
      linkbyoff.classList.remove("active");
      linkbb.classList.remove("active");
      linkbc.classList.remove("active");
      linkc.classList.remove("active");
      linkd.classList.remove("active");
      linke.classList.remove("active");
      linkf.classList.remove("active");
      linkg.classList.remove("active");
      linkh.classList.remove("active");
      linkj.classList.remove("active");
      linkc.classList.add("active");
    },
    goTo4thImageBulk() {
      const imageDivs = document.getElementsByClassName("4-image-bulk")
      const imageDiv = imageDivs[0]
      imageDiv.scrollIntoView({ behavior: "smooth", block: "start" });
    },
    goTo8ThImageBulk() {
      const imageDivs = document.getElementsByClassName("8-image-bulk")
      const imageDiv = imageDivs[0]
      imageDiv.scrollIntoView({ behavior: "smooth", block: "start" });
    },
    goMap() {
      location.href = "/map";
    },
    adjustElements() {
      const width = window.innerWidth;

      if (width < 1024) {
        this.modal = true;
      } else {
        this.modal = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
ol > li::marker {
  font-weight: bold;
}
.gray-line {
  border-bottom: 2px solid gray;
}
.link-href {
  color: #95c41c;

  &:hover {
    cursor: pointer;
  }
}
</style>
